import { actionCoreApi } from 'core/utils/api'
import { actionErrorNotifier } from 'core/utils/helpers'
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper'
import ActionsList from 'core/actions/Actions.list'
import { dispatcherActionType } from 'core/utils/interfaces'

export const getSCIMConfig = (accountId: string): dispatcherActionType =>
  actionErrorNotifier(
    actionCoreApi(
      ActionsList.FetchSCIMConfig,
      HTTPUrlHelper.getSCIMConfigAPI(accountId),
      'GET'
    )
  )

export const updateSCIMConfig = (id: string, payload: any, message?: any): dispatcherActionType =>
  actionErrorNotifier(
    actionCoreApi(
      ActionsList.UpdateSCIMConfig,
      HTTPUrlHelper.updateSCIMConfigAPI(id),
      'PUT',
      payload
    ),
    true,
    {
      title: '',
      message: message
    }
  )

export const generateSCIMToken = (payload: any, message?: any): dispatcherActionType =>
  actionErrorNotifier(
    actionCoreApi(
      ActionsList.GenerateSCIMToken,
      HTTPUrlHelper.generateSCIMTokenAPI(),
      'POST',
      payload
    ),
    true,
    {
      title: '',
      message: message
    }
  )
